import get from 'lodash/get';
import { ContentItem } from 'kentico-cloud-delivery';

export default class GlobalMetaTags extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get metaTags() {
    return get(this, '_tags.value', []);
  }
}



// WEBPACK FOOTER //
// ./src/models/GlobalMetaTags.js